import { humanize, isNotEmpty, isNotPresent } from "neetocist";
import { Modal, Typography, NoData, Tag } from "neetoui";
import { isEmpty } from "ramda";
import { useTranslation } from "react-i18next";

import Link from "./Link";
import {
  htmlToText,
  highlightMatch,
  filterAndHighlightContent,
  createStylePalette,
} from "./utils";

const getStyle = createStylePalette([
  "primary",
  "info",
  "success",
  "secondary",
  "warning",
]);

const ModalBody = ({ containerRef, data, onClose, loading, searchTerm }) => {
  const { t } = useTranslation();

  const categoryGroups = Object.keys(data).filter(key => isNotEmpty(data[key]));
  const isDataEmpty = isNotPresent(data) || isEmpty(categoryGroups);

  if (isDataEmpty && !loading) {
    return (
      <Modal.Body className="neeto-molecules-finder-modal__body flex h-96 items-center justify-center overflow-y-auto px-3 py-5">
        <NoData
          description={t("neetoMolecules.finderModal.noDataDesc")}
          title={t("neetoMolecules.finderModal.noDataTitle")}
        />
      </Modal.Body>
    );
  }

  return (
    <Modal.Body className="neeto-molecules-finder-modal__body h-96 overflow-y-auto px-3 py-4">
      <div className="flex flex-col" ref={containerRef}>
        {categoryGroups.map((category, categoryIndex) => {
          const items = data[category];
          const shouldShowCategoryDivider =
            categoryIndex < categoryGroups.length - 1;

          return (
            <div key={category}>
              {items.map(item => {
                const nameContent = htmlToText(item.name);
                const bodyContent = htmlToText(item.body);

                const filteredBodyContent = filterAndHighlightContent(
                  bodyContent,
                  searchTerm
                );

                return (
                  <Link
                    className="neeto-molecules-search-result-item hover:neeto-ui-bg-gray-100 focus:neeto-ui-bg-gray-100 neeto-ui-rounded-lg flex w-full cursor-pointer items-center gap-2 px-3 py-2.5 text-xs transition-all duration-300"
                    key={`${category}-${item.id}`}
                    to={item.url}
                    onClick={onClose}
                  >
                    <div className="line-clamp-1 flex flex-col gap-1">
                      <div className="flex">
                        {nameContent && (
                          <Typography
                            className="neeto-ui-text-black inline-block"
                            component="span"
                            lineHeight="snug"
                            weight="semibold"
                          >
                            {highlightMatch(nameContent, searchTerm)}
                            {category && (
                              <Tag
                                className="ml-2 inline-block align-middle"
                                size="small"
                                style={getStyle(category)}
                                type="solid"
                              >
                                {humanize(category)}
                              </Tag>
                            )}
                          </Typography>
                        )}
                      </div>
                      {bodyContent && (
                        <Typography className="neeto-ui-text-gray-600 truncate text-xs">
                          {filteredBodyContent || bodyContent}
                        </Typography>
                      )}
                    </div>
                  </Link>
                );
              })}
              {shouldShowCategoryDivider && (
                <hr className="neeto-ui-border-gray-300 mx-3 my-3 border-t" />
              )}
            </div>
          );
        })}
      </div>
    </Modal.Body>
  );
};

export default ModalBody;
